// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__WRBBd"};